import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    showMenu: true,
    showSnackError: false,
    snackTextError: '',
    showSnackSuccess: false,
    snackTextSuccess: '',
    showLoader: false,
    showProgress: false,
    progressValue: 0
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        hideMenu(state) {
            state.showMenu = false;
        },
        openMenu(state) {
            state.showMenu = true;
        },
        toggleMenu(state) {
            state.showMenu = !state.showMenu;
            localStorage.setItem('showMenu', (state.showMenu).toString());
        },
        showSnackError(state, action) {
            state.showSnackError = true;
            state.snackTextError = action.payload;
        },
        hideSnackError(state) {
            state.showSnackError = false;
            state.snackTextError = '';
        },
        showSnackSuccess(state, action) {
            state.showSnackSuccess = true;
            state.snackTextSuccess = action.payload;
        },
        hideSnackSuccess(state) {
            state.showSnackSuccess = false;
            state.snackTextSuccess = '';
        },
        toggleLoader(state, action) {
            state.showLoader = action.payload;
        },
        toggleProgress(state, action) {
            if (!action.payload) {
                state.progressValue = 0;
            }

            state.showProgress = action.payload;
        },
        setProgressValue(state, action) {
            state.progressValue = action.payload;
        }
    }
});

export const { toggleMenu, showSnackError, hideSnackError, showSnackSuccess, hideSnackSuccess, toggleLoader, hideMenu, openMenu, toggleProgress, setProgressValue } = globalSlice.actions;

export default globalSlice.reducer;
